export enum FreyrEventPrefix {
  CLICK_FROM = 'Click from',
}
